/**
 * Sidekicktool – localized cart drawer refresh
 *
 * Problem:
 * - component-cart.min.js sends sections_url: Shopify.routes.root
 * - Replo / landing-page add-to-cart does not re-render cart drawer in the active market
 * - Cart API data is correct (GBP) but drawer HTML shows USD until full page reload
 *
 * Install:
 * - Add to assets/
 * - Load in theme.liquid BEFORE component-cart.min.js:
 *     <script src="{{ 'cart-sections-url-fix.js' | asset_url }}" defer></script>
 */
(function () {
  'use strict';

  if (window.__sidekickCartSectionsUrlFix) return;
  window.__sidekickCartSectionsUrlFix = true;

  function getSectionsUrl() {
    var path = window.location.pathname;
    if (path && path !== '/') return path;
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function patchCartBody(body) {
    if (!body || typeof body !== 'object') return body;

    if (body.sections || body.sections_url != null) {
      body.sections_url = getSectionsUrl();
    }

    return body;
  }

  var originalSend = XMLHttpRequest.prototype.send;
  var originalOpen = XMLHttpRequest.prototype.open;

  XMLHttpRequest.prototype.open = function (method, url) {
    this.__sidekickCartMethod = method;
    this.__sidekickCartUrl = url;
    return originalOpen.apply(this, arguments);
  };

  XMLHttpRequest.prototype.send = function (body) {
    if (
      this.__sidekickCartMethod === 'POST' &&
      typeof this.__sidekickCartUrl === 'string' &&
      /\/cart\/(add|change|update)\.js/.test(this.__sidekickCartUrl) &&
      body
    ) {
      try {
        var data = JSON.parse(body);
        body = JSON.stringify(patchCartBody(data));
      } catch (error) {}
    }

    return originalSend.call(this, body);
  };

  function getCartSectionIds() {
    var nodes = document.querySelectorAll('.js-update-on-cart-change');
    var ids = [];

    nodes.forEach(function (node) {
      var section = node.closest('.shopify-section');
      if (!section || !section.id) return;
      ids.push(section.id.replace('shopify-section-', ''));
    });

    return Array.from(new Set(ids)).slice(0, 5);
  }

  async function refreshLocalizedCartDrawer() {
    if (!window.EventBus) return;

    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var sectionIds = getCartSectionIds();
    if (!sectionIds.length) return;

    try {
      var response = await fetch(root + 'cart/update.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          sections: sectionIds,
          sections_url: getSectionsUrl()
        })
      });

      var cart = await response.json();
      if (!cart || !cart.sections) return;

      var target = document.querySelector('.js-cart-main');
      window.EventBus.emit('cart:updated', {
        cart: cart,
        targetId: target ? target.id : null
      });
    } catch (error) {
      console.error('Localized cart drawer refresh failed', error);
    }
  }

  if (window.EventBus) {
    window.EventBus.on('cart:changed', function () {
      window.requestAnimationFrame(refreshLocalizedCartDrawer);
    });
  }

  var originalFetch = window.fetch;
  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : input && input.url;

    if (
      typeof url === 'string' &&
      /\/cart\/(add|change|update)\.js/.test(url) &&
      init &&
      init.method === 'POST' &&
      init.body
    ) {
      try {
        var body = JSON.parse(init.body);
        init = Object.assign({}, init, {
          body: JSON.stringify(patchCartBody(body))
        });
      } catch (error) {}
    }

    var result = originalFetch.call(this, input, init);

    if (typeof url === 'string' && /\/cart\/add\.js/.test(url)) {
      result.then(function () {
        window.requestAnimationFrame(refreshLocalizedCartDrawer);
      });
    }

    return result;
  };
})();
